var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#FFDBDB",
    stroke: "#FC5D5B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 30H14.5909C13.0455 30 11.8163 29.248 10.7127 28.1966C8.45337 26.0441 12.1628 24.324 13.5776 23.4816C15.9768 22.053 18.8425 21.6575 21.5 22.2952",
    stroke: "#FC5D5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 14.5C24.5 16.9853 22.4853 19 20 19C17.5147 19 15.5 16.9853 15.5 14.5C15.5 12.0147 17.5147 10 20 10C22.4853 10 24.5 12.0147 24.5 14.5Z",
    stroke: "#FC5D5B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7596 24.378C23.6796 24.378 23.2171 25.1576 23.0971 25.6373C22.9771 26.117 22.9771 27.856 23.0491 28.5755C23.2891 29.475 23.8891 29.8468 24.4771 29.9667C25.0171 30.0147 27.2971 29.9967 27.9571 29.9967C28.9171 30.0147 29.6371 29.6549 29.9371 28.5755C29.9971 28.2157 30.0571 26.2369 29.9071 25.6373C29.5891 24.6778 28.866 24.378 28.266 24.378M24.7596 24.378H28.266M24.7596 24.378C24.7596 24.378 24.7582 23.5516 24.7596 23.1173C24.7609 22.7204 24.726 22.3378 24.9156 21.9876C25.626 20.5748 27.666 20.7187 28.17 22.1579C28.2573 22.3948 28.2626 22.7704 28.26 23.1173C28.2567 23.5605 28.266 24.378 28.266 24.378",
    stroke: "#FC5D5B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateIcon);
export default __webpack_public_path__ + "static/media/privateIcon.b77f950ae250cd07643dcd2756869877.svg";
export { ForwardRef as ReactComponent };